/// <reference path="../types/index.d.ts" />

import '../client_forms/losserranos/style.css';
import FormStructure from './losserranos/form_structure';

export default FormStructure;